import { createFileRoute, useLoaderData } from '@tanstack/react-router';

import { useTranslation } from 'react-i18next';
import data from '@/data/privacy-policy.json';
import { t as ts } from '@/lib/i18n';
import Section from '@/components/layout/section.tsx';
import PageTitle from '@/components/layout/page-title.tsx';
import Breadcrumbs from '@/components/layout/breadcrumbs.tsx';

export const Route = createFileRoute('/privacy-policy')({
	component: PrivacyPolicy,
	head: () => ({
		meta: [
			{
				name: 'apple-mobile-web-app-title',
				content: `Jervice - ${ts('privacy_policy.title')}`,
			},
			{
				name: 'og:title',
				content: `Jervice - ${ts('privacy_policy.title')}`,
			},
			{
				name: 'og:image',
				content: `/images/main.png`,
			},
			{
				name: 'twitter:title',
				content: `Jervice - ${ts('privacy_policy.title')}`,
			},
			{
				name: 'twitter:image',
				content: `/images/main.png`,
			},
			{ title: `Jervice - ${ts('privacy_policy.title')}` },
		],
	}),
});

function PrivacyPolicy() {
	const { t } = useTranslation();
	const parentData = useLoaderData({ from: '__root__' });

	return (
		<Section className="flex flex-col gap-6 py-6 max-md:py-4">
			<Breadcrumbs
				items={[{ title: t('global.menu.home'), link: '/' }, { title: t('privacy_policy.title') }]}
			/>

			<PageTitle className="text-[var(--primary)] mb-4">{t('privacy_policy.title')}</PageTitle>

			<div className="grid grid-cols-12 gap-4">
				{data?.map((item: any, index: number) => {
					return (
						<div
							key={`pp_${item?.id}_${index}`}
							className="col-span-4 max-xl:col-span-6 max-md:col-span-12"
						>
							<h3 className="font-bold text-3xl max-md:text-2xl text-neutral-600 mb-2">
								{t(`privacy_policy.${item.title}`)}
							</h3>
							{item?.caption && (
								<p className="text-neutral-500">{t(`privacy_policy.${item.caption}`)}</p>
							)}

							{item?.list?.length && (
								<ul className="pl-4">
									{item?.list?.map((line: any, i: number) => {
										return (
											<li
												className="list-disc text-neutral-500"
												key={`pp_line_${item?.id}_${index}_${i}`}
											>
												{t(`privacy_policy.${line}`)}
											</li>
										);
									})}
								</ul>
							)}

							{item?.email && (
								<a href={`mailto:${parentData?.contactEmail}`} className="w-fit block">
									<p className="text-neutral-500">
										{t(`privacy_policy.${item.email.lang_key}`, {
											email: parentData?.contactEmail,
										})}
									</p>
								</a>
							)}

							{item?.phone && (
								<a href={`tel:${parentData?.contactPhone}`} className="w-fit block">
									<p className="text-neutral-500">
										{t(`privacy_policy.${item.phone.lang_key}`, {
											phone: parentData?.contactPhone,
										})}
									</p>
								</a>
							)}
						</div>
					);
				})}
			</div>
		</Section>
	);
}
